import { gsap } from 'gsap';
import { hamburgerMenu } from "./_hamburgerMenu";
import { smoothScroll } from "./_smoothScroll";
import { animationTop } from "./animations/top/index.js";
import { initProjectsSplide } from "./_splideInit";
import { filterAccordion } from "./_filterAccordion";
import { projectFilter } from "./_projectFilter";
import { animationRecruit } from "./animations/recruit/index.js";
import { recruitRequirements } from "./_recruitRequirements";
import { recruitFaq } from "./_recruitFaq";
import { animationCrosstalk } from "./_animationCrosstalk";
import { animationFooter } from "./_animationFooter";
import { animationHeader } from "./_animationHeader";
import { animationPageHeader } from "./_animationPageHeader";
import { animationWho } from "./_animationWho";
import { infiniteScroll } from "./_infiniteScroll";
import { animationLabel } from "./_animationLabel";
import { initPageTransition } from "./_pageTransition";
import { initTouchDeviceDetection } from "./_touchDeviceDetection";

// ブラウザのデフォルトのスクロール位置復元を使用
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'auto';
}

// リサイズ時の処理（横幅が変わったらリロード）
function setupScrollTriggerRefresh() {
    let resizeTimeout;
    let currentWidth = window.innerWidth;
    let currentHeight = window.innerHeight;
    let isZoomed = false;

    // フォーカス時のズーム検知
    document.addEventListener('focusin', (e) => {
        if (e.target.matches('input, textarea, select')) {
            isZoomed = true;
            setTimeout(() => {
                isZoomed = false;
            }, 1000); // 1秒後にズームフラグをリセット
        }
    });

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const newWidth = window.innerWidth;
            const newHeight = window.innerHeight;

            // ズーム中の場合はリロードしない
            if (isZoomed) {
                currentWidth = newWidth;
                currentHeight = newHeight;
                return;
            }

            // 横幅が変わった場合のみリロード（縦幅の変更は無視）
            if (newWidth !== currentWidth) {
                // スマホのURLバー表示/非表示による縦幅変更を防ぐため
                sessionStorage.setItem('isResizeReload', 'true');
                window.location.reload();
            }

            // 縦幅のみ変わった場合は現在の高さを更新するだけ
            if (newHeight !== currentHeight && newWidth === currentWidth) {
                currentHeight = newHeight;
            }
        }, 300); // 300ms後にチェック（リサイズが完了してから）
    });
}

// ページの内容が完全に読み込まれた後のイベント
document.addEventListener('DOMContentLoaded', () => {


    // ページトランジション初期化（全ページ共通のフェードイン/アウト）
    initPageTransition();

    // メインタグのID取得
    const mainElement = document.querySelector('main');
    const pageId = mainElement ? mainElement.getAttribute('id') : null;

    // ページ固有の関数実行
    const pageFunctions = {
        'top': [animationTop, initProjectsSplide, filterAccordion, projectFilter],
        'business-field': [initProjectsSplide, filterAccordion, projectFilter],
        'recruitment': [animationRecruit, recruitRequirements, recruitFaq],
        'crosstalk': [animationCrosstalk],
        'who-we-are': [animationWho],
        'project-portfolio': [filterAccordion, infiniteScroll],
        'project-portfolio-single': [filterAccordion, initProjectsSplide],
    };

    // 全ページ共通で実行
    hamburgerMenu();
    smoothScroll();
    animationHeader();
    animationPageHeader();
    animationFooter();
    animationLabel();
    setupScrollTriggerRefresh();
    initTouchDeviceDetection();
    
    // リロード時のScrollTrigger問題を解決
    // ページ読み込み完了後にScrollTriggerをリフレッシュ
    window.addEventListener('load', () => {
        setTimeout(() => {
            if (typeof ScrollTrigger !== 'undefined') {
                ScrollTrigger.refresh();
            }
        }, 300); // シンプルに300ms後に実行
    });

    // ページ固有の関数を実行
    if (pageId && pageFunctions[pageId]) {
        pageFunctions[pageId].forEach(fn => {
            if (typeof fn === 'function') {
                try {
                    fn();
                } catch (error) {
                    console.error(`ページID ${pageId} の関数実行中にエラーが発生しました:`, error);
                }
            } else {
                console.error(`ページID ${pageId} に対して関数が期待されましたが、${typeof fn} が得られました`);
            }
        });
    }
});